<template>
  <div>
    <div v-if="expanded" class="modal-block"></div>
    <header id="cabecalho" :style="( arealogada ? 'position: absolute;top:0;':'')">
      <b-navbar toggleable="xl" type="dark" variant="info"
        style="z-index: 1000;"
        :style="(arealogada && !mobile) ? 'box-shadow: 0px 3px 6px #00000005;' : ''">
        <b-navbar-brand style="cursor:pointer;">
          <a @click="$router.push({ name: 'home' })">
            <img
              @click="!totem ? $router.push({ name: 'home' }) : false" id="logo-header" alt="CENPROT Logo"
              src="~@/assets/imgs/logo.svg">
          </a>
        </b-navbar-brand>

        <b-navbar-toggle class="navtoggle-btn" ref="btnCollapse" target="nav-collapse" @click="isExpanded">
          <template v-slot:default>
            <font-awesome-icon v-if="expanded" icon="times" class="navcontroler-times" />
            <font-awesome-icon v-else icon="bars" class="navcontroler-bars" />
          </template>


        </b-navbar-toggle>
        <b-collapse id="nav-collapse" class="navbar-main" is-nav>
          <b-navbar-nav class="navbar-navigation" v-if="!$root.isDevice">
            <div v-if="logged" class="navbar-userdata-container">
              <h2>{{ usuarioLogado.nomeAbreviado }}</h2>
              <h3>{{ usuarioLogado.email }}</h3>
            </div>
            <b-nav-item :href="'/cadastroUser'" v-if="logged" class="mobile">Meus dados</b-nav-item>
            <b-nav-item :href="'/painel'" v-if="logged" class="mobile">Painel do usuário</b-nav-item>
            <b-nav-item href="/" @click="$root.logout()" v-if="logged" class="mobile">Sair</b-nav-item>
            <b-nav-item href="/login" v-if="!logged" class="mobile">Entrar</b-nav-item>
            <b-nav-item @click="isExpanded" href="/" v-if="!totem && !mobile">Início</b-nav-item>
            <b-nav-item @click="isExpanded" href="/servicos" v-if="!totem && !mobile">Serviços</b-nav-item>
            <!-- <b-nav-item @click="isExpanded" href="/#como-funciona" class="p-3">Como funciona</b-nav-item> -->
            <b-nav-item href="/cartorios" v-if="!totem && !mobile">Cartórios participantes</b-nav-item>
            <b-nav-item href="https://blog.pesquisaprotesto.com.br" target="_blank" v-if="!totem && !mobile">Notícias</b-nav-item>
            <!-- <b-nav-item href="/blog" class="p-3" >Blog</b-nav-item> -->
            <!-- <b-nav-item @click="isExpanded" href="https://api.whatsapp.com/send?phone=551135045941"  target="_blank" class="p-3" v-if="!totem">Ajuda</b-nav-item> -->
            <b-nav-item @click="isExpanded" v-if="!totem && !mobile">Ajuda</b-nav-item>

            <b-nav-item href="/atendimento" v-b-toggle.sidebar-right v-if="!totem && !mobile">Atendimento</b-nav-item>
            <!-- <b-nav-item class=" active btn-sair" v-if="logged && mobile" @click="$root.logout()">
          Sair <font-awesome-icon icon="sign-out-alt"/>
          </b-nav-item> -->
          </b-navbar-nav>
          <b-navbar-nav class="navbar-navigation mobile" v-else>
            <b-spinner v-if="!totem && loading" class="user-loading-spinner d-none d-xl-block" variant="primary" label="Spinning"></b-spinner>
            <b-nav-item :href="'/cadastroUser'" v-if="logged && !loading" class="mobile">Meus dados</b-nav-item>
            <b-nav-item :href="'/painel'" v-if="logged && !loading" class="mobile">Painel do usuário</b-nav-item>
            <b-nav-item href="/" @click="$root.logout()" v-if="logged && !loading" class="mobile">Sair</b-nav-item>
            <b-nav-item href="/login" v-if="!logged && !loading" class="mobile">Entrar</b-nav-item>
          </b-navbar-nav>
          <!-- <nossosservicos class="d-block d-xl-none" id="nossos-servicos" :navbar="true" :logged="logged" /> -->
          <div class="navbar-navbutton-para-empresa d-block d-xl-none">
            <b-nav-item href="/saiba-mais" class="btn-saiba-mais">Para empresas</b-nav-item>
          </div>

        </b-collapse>
        <!-- Right aligned nav items -->
        <b-collapse id="navbar-buttons" class="navbar-buttons" :style="( arealogada ? 'position: absolute;right: -60px;':'')" is-nav>
          <b-spinner v-if="!totem && loading" class="user-loading-spinner d-none d-xl-block" variant="primary" label="Spinning"></b-spinner>
          <b-navbar-nav class="navbar-usersection" v-if="!totem && !loading">
            <button @click="abreLink(true, '/cadastro')" v-if="!logged" class="btn-primary btn-cadastro">Cadastre-se</button>
            <b-nav-form>
              <b-nav-item href="/login" v-if="!logged" class="btn-entrar">Entrar</b-nav-item>

              <!-- <b-button  squared class="my-2 my-sm-0 btn-proteste" ><a href="/PedidoProtesto" class="aprotesteja">PROTESTE JÁ</a></b-button> -->
              <b-dropdown variant="none" class="nav-item p-login blocktext painel-cliente custom-dropdown"  v-if="logged">
                <template v-slot:button-content>
                  <span class="btn-nmAb"> <font-awesome-icon icon="user" class="icon-nmAb" />{{ usuarioLogado.nomeAbreviado }}</span>
                </template>
                <b-dropdown-item class="border-bottom-all" v-if="logged" :href="'/cadastroUser'">
                  <span class="btn-nmAb-inner"><font-awesome-icon icon="sliders-h" class="icon-nmAb mr-2" />Meus dados</span>
                </b-dropdown-item>
                <b-dropdown-item class="border-bottom-all" v-if="logged" :href="'/painel'">
                  <span class="btn-nmAb-inner"><font-awesome-icon icon="address-card" class="icon-nmAb mr-2" />Painel do usuário</span>
                </b-dropdown-item>
                <b-dropdown-item  v-if="logged" @click="$root.logout()" class="active btn-sair">
                  <span class="btn-nmAb-inner"><font-awesome-icon icon="sign-out-alt" class="icon-nmAb mr-2" />Sair</span>
                </b-dropdown-item>
              </b-dropdown>


            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-navbar toggleable="xl" type="dark" variant="info" class="subnav d-none d-xl-block" v-if="!arealogada && !totem">
        <b-collapse id="nav-collapse" class="p-5 navbar-servicos" is-nav>
          <b-navbar-nav>
            <b-dropdown text="Protesto">
              <b-dropdown-item href="/servico/consulta-documento">Consulta de CPF/CNPJ</b-dropdown-item>
              <b-dropdown-item href="/servico/envio-de-titulo">Envio de Títulos</b-dropdown-item>
              <b-dropdown-item href="/servico/autenticidade-protesto">Verificação de Autenticidade</b-dropdown-item>
            </b-dropdown>
            <b-dropdown text="Cancelamento de protesto">
              <b-dropdown-item href="/servico/pedido-anuencia">Autorização de Cancelamento<br>(Carta de anuência
                eletrônica)</b-dropdown-item>
                <!--<b-dropdown-item href="/cancelamento-protesto">Cancelamento de protesto</b-dropdown-item>-->
            </b-dropdown>
            <b-dropdown text="Edital Eletrônico">
              <b-dropdown-item href="/servico/consulta-edital">Consulta de Edital</b-dropdown-item>
              <!-- <b-dropdown-item href="/jornal-eletronico">Jornal Eletrônico</b-dropdown-item> -->
              <!-- <b-dropdown-item href="/servico/quitar-debitos">Quitar débitos protestados</b-dropdown-item> -->
            </b-dropdown>
            <b-dropdown text="Certidão">
              <b-dropdown-item href="/servico/pedido-certidao">Pedido de certidão</b-dropdown-item>
              <b-dropdown-item href="/servico/autenticidade-certidao">Verificação de Autenticidade</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
  </div>
</template>

<script>
import nossosservicos from "../../components/nossos_servicos";

export default {
  components: {
    nossosservicos,
  },
  props: {
    home: Boolean,
    // logged: Boolean,
    arealogada: Boolean,
    totem: Number
  },
  data() {
    return {
      loading: true,
      status: false,
      expanded: false,
      logged: false,
      mobile: window.innerWidth < 1200,
      menu: {
        0: [1, 'home'],
        1: [2, 'servicos'],
        2: [3, 'certidao'],
        3: [4, 'anuencia'],
        4: [5, 'cancelamento'],
        5: [6, 'sabia'],
        6: [7, 'contato']
      },
      usuarioLogado: { nome: '', email: '', nomeAbreviado: '' }
    }
  },
  methods: {
    abreLink(interno = false, link){
      if(interno) this.$router.push('/cadastro');
      else window.open(link, "_blank");
    },
    nomeAbreviado(name) {
      let abreviado = '';
      let nameArray = name.split(' ');

      // Iterar sobre cada palavra no nome
      nameArray.forEach(nome => {
        // Adicionar apenas a primeira letra de cada palavra (em maiúsculas)
        abreviado += nome.charAt(0).toUpperCase() + '.';
      });

      return abreviado;
    },
    isExpanded: function () {
      if (window.innerWidth < 1200) {
        if (event.target.classList.value.includes('nav-link')) {
          this.$refs.btnCollapse.$el.click();
        }
        else {
          this.expanded = !this.expanded;
        }
      }
      if (this.expanded) document.body.classList.add('noscroll')
      else document.body.classList.remove('noscroll');
      ;
    },
    go(section, route) {
      if (this.home && route) this.$router.push({ name: section })
      // eslint-disable-next-line
      // else if(this.home && route == undefined)fullpage_api.moveTo(section)
      else if (!this.home && route == undefined) this.$router.push({ name: 'home', params: { 'section': section } })
      //console.log(this.home, route)
      /*if(this.home && !route) {
        // eslint-disable-next-line
        fullpage_api.moveTo(section)
        console.log("fll")
      } else {
        // volta para home -> seção
        this.$router.push({ name: section })
      }*/
    },
    menuItem() {
      return this.home ? 0 : 1
    }

  },
  created() {
    this.loading = true;
    const handleLogin = async () => {
      try {
        await this.$root.isLogged();
        this.logged = true;
        this.usuarioLogado.nome = localStorage.getItem("usrName");
        this.usuarioLogado.email = localStorage.getItem("usrEmail");
        this.usuarioLogado.nomeAbreviado = this.nomeAbreviado(this.usuarioLogado.nome);
      } catch (error) {
        this.logged = false;
        if(this.arealogada) this.$router.push({ name: 'login' });
      } finally {
        this.loading = false;
      }
    };
    setTimeout(() => {
      handleLogin();
    }, 1000);
    this.mobile = window.innerWidth < 1200;
    if (!this.home && document.getElementById('cabecalho') != null) document.getElementById('cabecalho').classList.add('azul')
  }
}
</script>

<style scoped>
.navbar-toggler {
  width: 34px;
  height: 34px;
  display: none;
  align-items: center;
  justify-content: center;
}

.navbar-toggler svg {
  color:var(--navbar-gray-color);
  height: auto;
  width: 29px;
}

.navbar-toggler svg.navcontroler-times {
  width: 14px;
  height: auto;
  border: 3px solid var(--navbar-gray-color) !important;
  padding: 3px 6px;
}

#cabecalho {
  display: flex;
  width: 100vw;
  height: fit-content;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 1000;
  position: relative;
}

.navbar {
  height: 80px;
  max-width: 1387px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 50px;
  padding:0;
}
.navbar-brand{padding: 0;display: flex;margin: 0;margin-left: 130px;}
.bg-info {
  background-color: rgb(255, 255, 255) !important;
}
.navbar-main{
  flex-grow: 1;
}
.navbar-buttons{
  flex-grow: 0;
}
.navbar-dark .navbar-nav {
  height: inherit;
  margin: 0;
  padding: 0;
  width: fit-content;
  display: flex;
}
.navbar-dark .navbar-nav.navbar-usersection{
  display: flex;
  align-items: center;
  justify-content: center;
  gap:31px;
}
.navbar-dark .navbar-nav.navbar-navigation{
  width: 100%;
  max-width: 884px;
}
.navbar-dark .navbar-nav .nav-item{
  height: inherit;
  flex-grow: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar-dark .navbar-nav.navbar-navigation .nav-item .nav-link:hover::after{
  opacity: 1;
}
.navbar-dark .navbar-nav.navbar-navigation .nav-item .nav-link::after{
  content:'';
  width: 100%;
  height: 3px;
  background-color: var(--primary-color);
  display: flex;
  opacity: 0;
  position: relative;
  bottom: 0;
  transition: opacity 0.16s ease-in;
}

.navbar-dark .navbar-nav.navbar-navigation .nav-item:not(:last-child)::after{
  display: flex;
  content:'';
  width: 1px;
  height: 21px;
  background-color: #EDF0F2;
}
.navbar-dark .navbar-nav .nav-link{
	font-family: var(--font-family);
	font-size: 16px;
	color: var(--navbar-gray-color);
	letter-spacing: -1%;
  cursor: pointer;
  height:inherit;
  padding: 0;
  line-height: 77px;
  width: 100%;
  font-weight: 300;
}

.navbar-dark .navbar-nav .btn-entrar .nav-link{
	padding: 0 20px;
}
.btn-primary.btn-cadastro{
  font-size: 16px;
  font-weight: 300;
}
.btn-entrar:hover{
  color: var(--primary-color);
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:active,
.navbar-dark .navbar-nav .nav-link:focus-within,
.navbar-dark .navbar-nav .nav-link:focus {
  color: var(--navbar-gray-color);
}

nav.navbar.subnav{
  height: 40px;
  width: 100%;
  padding: 0;
}


.btn-secondary:focus {
  box-shadow: none !important;
}


.p-login {
  padding: 0 3.5rem !important;
}


/* MELHORIA */

.navbar-nav .navbar-userdata-container {
  width: 100%;
  display: flex;
  flex-flow: column;
}

.navbar-nav .navbar-userdata-container h2 {
  font: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--navbar-gray-color);
  line-break: anywhere;
  text-transform: none;
}

.navbar-nav .navbar-userdata-container h3 {
  font: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--navbar-gray-color) !important;
  line-break: anywhere;
  text-transform: lowercase;
}
.navbar-nav .navbar-userdata-container::after {
  content: '';
  display: flex;
  width: 100%;
  height: 1px;
  background: var(--navbar-gray-color);
  margin-top: 10px;
}

.p-login.painel-cliente {
  padding: 0 !important;
  width: 100%;
  height: 44px;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 187px;
}
.p-login.painel-cliente:focus-within {
  outline: none;
}
.p-login.painel-cliente.show,
.p-login.painel-cliente:hover {
}
.p-login.painel-cliente.show {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border: 3px solid white !important;
  box-shadow: 4px 4px 50px 0 #D1DBE2;
}
.p-login.painel-cliente.show .btn-nmAb,
.p-login.painel-cliente:hover .btn-nmAb {
  /* color:white; */
}

.p-login.painel-cliente.show .btn-nmAb svg,
.p-login.painel-cliente:hover .btn-nmAb svg {
  /* color: white !important; */
}
/* .btn-sair {
  padding: 0;
} */
.p-login.painel-cliente .btn-nmAb-inner{  
  font: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -1%;
  color: var(--navbar-gray-color);
}
.p-login.painel-cliente .btn-nmAb-inner svg {
  font: normal normal bold 16px/16px 'Kanit', sans-serif;
  margin-bottom: -1.5px;
  margin-left: -8px;
}
.btn-sair .sair-btn-icon {
  width: 20px;
  height: 18px;
  margin-left: 8px;
  background: url("../../assets/imgs/icones/btn-sair.png");
  background-position: center;
  background-size: cover;
}

.btn-sair:hover .sair-btn-icon {
  background: url("../../assets/imgs/icones/btn-sair-grey.png");
  background-position: center;
  background-size: cover;
}

.navbar-nav .btn-sair.active a.nav-link {
  text-align: center;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

.navbar-nav .btn-sair.active a.nav-link:hover {
  color: #7A7A7A !important;
}

.navbar-nav .navbar-userdata-container {
  display: none;
}

/* FIM MELHORIA */
@media (max-width: 1440px) {
	.navbar {padding: 0 40px;}
}
@media (max-width: 992px){
	.navbar-brand {margin-left: 40px;}
}

@media (max-width: 600px){
	.navbar {padding: 0 15px;}
	.navbar-brand {margin-left: 0px;}
}

/* MELHORIA */
@media (min-width: 1200px) {
  .p-3 {
    padding: 0rem !important;
  }

  .p-3 a.nav-link {
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    padding: 0 0.5rem;
  }

  @keyframes slideNavbarIn {
    from {
      transform: translateX(calc(-100% - 0.5rem));
    }

    to {
      transform: translateX(0%);
    }
  }

  @keyframes slideNavbarOut {
    0% {
      transform: translateX(0%);
    }

    99% {
      transform: translateX(calc(100%));
    }

    100% {
      transform: translateX(calc(-100% - 0.5rem));
    }
  }
}

@media (min-width: 1200px) and (max-width: 1400px) {
  .btn-proteste {
    width: 180px;
  }

  .p-login {
    padding: 0 2.5rem !important;
  }

  .navbar-dark .navbar-nav .nav-link,
  .btn-proteste,
  .p-3 a.nav-link {
    font-size: 0.8rem;
  }
}

/* FIM MELHORIA */
.mobile{display: none !important;}
@media (max-width: 1199px) {
  .navbar-buttons{
    max-width: unset;
    border: 3px solid white;
    z-index: 100;
    box-shadow: 4px 4px 50px 0 #D1DBE2;
    background: white;
    position: relative;
  }
  .mobile{display: flex !important;}
  .modal-block {
    width: 100vw;
    height: 100vh;
    z-index: 50;
    background-color: #000000;
    opacity: 0.3;
    position: fixed;
    top: 0;
  }

  .navbar {
    height: 68px;
  }

  .navbar-toggler {
    font-size: 1.75rem;
    background: transparent;
    padding: 0;
    display: flex;
  }
  
  .navbar-dark .navbar-nav .nav-item{
    width: 100%;
    height: fit-content;
    border-bottom: 1px solid var(--navbar-gray-color);
  }
  .navbar-dark .navbar-nav .nav-link{
    line-height: 30px;
    padding: 12px 0;
  }

  .navbar-nav {
    width: 100%;
    align-items: center;
    margin: 0;
  }

  #nav-collapse {
    display: flex;
    background: var(--light-gray-color);
    position: fixed;
    top: 68px;
    width: 393px;
    max-width: 80vw;
    flex-direction: column;
    right: 0px;
    padding: 0px 23px 3px 23px !important;
    border-bottom: 23px solid var(--light-gray-color);
    z-index: 100;
    /* height: 76vh; */
    transform: translateX(100%);
    transition: transform cubic-bezier(0.59, 0.02, 0.13, 1.01) .5s;
    overflow-y: scroll;
    border-right: 7px solid var(--light-gray-color);
    border-top: 23px solid var(--light-gray-color)  ;
    overflow-x: hidden;
    height: fit-content;
    max-height: 76vh;
  }
  #nav-collapse.collapsing{
    height: 0px !important;
    transition: all 0.16ms ease-in-out;
  }

  #nav-collapse::-webkit-scrollbar {
    width: 3px;
  }

  #nav-collapse::-webkit-scrollbar-track {
    background-color: var(--light-gray-color);
  }

  #nav-collapse::-webkit-scrollbar-thumb {
    background-color: #A8A8A8;
  }

  #nav-collapse::-webkit-scrollbar-thumb:hover {
    background-color: #8c8c8c;
  }

  #nav-collapse.show {
    transform: translateX(0%);
  }
  .navbar-dark .navbar-nav.navbar-navigation .nav-item::after {
    display: none !important;
  }
  .navbar-dark .navbar-nav.navbar-navigation .nav-item .nav-link:hover::after{
    opacity: 0;
  }
/* 
  .navbar-nav li.form-inline form.form-inline .btn-entrar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  } */

  .navbar-nav.navbar-navigation {
    padding: 0;
    margin-bottom: 4px;
    height: fit-content;
  }

  .navbar-navbutton-para-empresa {
    width: 100%;
    padding-top: 13px;
    margin-top: 19px;
  }

  .navbar-navbutton-para-empresa .btn-saiba-mais {
    width: 100%;
    list-style: none;
  }

  .navbar-navbutton-para-empresa .btn-saiba-mais a {
    width: fit-content;
    margin: 0 auto;
    border: none;
    border-radius: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 49px;
    color: #FFFFFF;
    font-family:'Kanit', sans-serif;
    font-size: 20px;
    font-weight:400;
    letter-spacing: -1%;
    text-transform: none;
    background-color: var(--primary-color);
  }

  .navbar-navbutton-para-empresa .btn-saiba-mais a img {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  .nav-bar-item.blocktext {
    margin-left: auto;
    margin-right: auto;
    width: 6em;
  }

  .navbar-toggler-icon {
    width: 60px;
    height: 8px;
    top: 7px;
    right: 9px;
    position: absolute;
    background-color: #000;
    transition: all .3s linear;
    z-index: 20;
  }

  .dropdown-item:hover, .dropdown-item:focus {
  background-color: #000000;
  }

  /* .btn-sair {
    height: 88px;
    font-weight: 700;
    font-size: 30px;
    height: calc(calc(100vh - 60px) / 9);
    align-items: center;
    display: flex;
    justify-content: flex-end;
    width: calc(100% - 40px);
  } */

  /* .btn-sair>a {
    margin-right: 24px;
    font-size: 22px;

  } */

  .p-login.painel-cliente {
    width: 100%;
    margin: 0;
  }

  .navbar-nav .navbar-userdata-container {
    display: flex;
  }


}

.aprotesteja {
  background-color: #597EB5;
  color: rgb(255, 255, 255);
  text-decoration: none;
}

@media (max-width:420px) {
  #nav-collapse {
    max-width: 98vw;
  }

}

.btn-nmAb{
  /* color: #597EB5; */
  /* font-weight: bold; */
  /* font-size: 13px; */
}
.custom-dropdown-button{
  /* color: #597EB5; */
  color: var(--navbar-gray-color);
}

.btn-nmAb:hover{
  /* color: rgb(255, 255, 2552); */
  /* font-weight: bold; */
}
.icon-nmAb:hover {
  /* color: rgb(255, 255, 255); */
}
.icon-nmAb{
  float: left;
  margin-top: 6px;
  color: var(--navbar-gray-color);
}

.border-bottom-all{
  border-bottom: 0.5px solid var(--navbar-gray-color);
}
.user-loading-spinner{
  margin-left:auto;
}


@media (max-width:1199px){  
  .p-login.painel-cliente.show{
    margin-bottom: 128px;
  }
}
</style>
